import { render, staticRenderFns } from "./Complaints.vue?vue&type=template&id=cee75508&"
import script from "./Complaints.vue?vue&type=script&lang=ts&"
export * from "./Complaints.vue?vue&type=script&lang=ts&"
import style0 from "./Complaints.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports